/* Delegate so filtered grids and theme-editor sections work without rebinding. */
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('.dannto-colors-toggle');
  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    const group = toggle.closest('.dannto-color-swatches');
    const expanded = group.classList.toggle('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute('aria-label', expanded ? 'Show fewer colors' : 'Show all colors');
    toggle.textContent = expanded ? '−' : toggle.dataset.moreLabel;
    return;
  }
  const swatch = event.target.closest('a.dannto-color-swatch');
  if (!swatch) return;
  const card = swatch.closest('product-grid-item');
  const id = swatch.getAttribute('data-grid-item-variant');
  const variants = card && card.querySelectorAll('product-grid-item-variant');
  const target = variants && Array.from(variants).find(el => el.getAttribute('data-grid-item-variant') === id);
  if (!target) return;
  event.preventDefault();
  // Also switch here in case the theme upgraded the card before parsing its links.
  variants.forEach(el => { el.hidden = el !== target; });
  target.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
  card.querySelectorAll('a.dannto-color-swatch').forEach(el => {
    el.removeAttribute('aria-current');
    el.removeAttribute('aria-selected');
  });
  swatch.setAttribute('aria-selected', 'true');
  const info = card.querySelector('.product__grid__info > a[data-grid-link]');
  const template = swatch.querySelector('template[data-dannto-card-info]');
  if (info && template) info.replaceWith(template.content.cloneNode(true));
});

/* Equalize mobile title space by visual product row, including color switches. */
(function () {
  let pending = false;
  function alignTitles() {
    pending = false;
    document.querySelectorAll('.js-grid').forEach(grid => {
      const titles = Array.from(grid.querySelectorAll('.product__grid__title'));
      titles.forEach(title => { title.style.minHeight = ''; });
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const rows = new Map();
      titles.forEach(title => {
        const card = title.closest('.product-grid-item');
        if (!card || !card.getClientRects().length) return;
        const top = Math.round(card.getBoundingClientRect().top);
        const group = rows.get(top) || [];
        group.push(title);
        rows.set(top, group);
      });
      rows.forEach(group => {
        const height = Math.ceil(Math.max(...group.map(title => title.getBoundingClientRect().height)));
        group.forEach(title => { title.style.minHeight = height + 'px'; });
      });
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(alignTitles);
  }
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('load', schedule, true);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();
